import { render, staticRenderFns } from "./EducationInfoTab.vue?vue&type=template&id=687d1997"
import script from "./EducationInfoTab.vue?vue&type=script&lang=js"
export * from "./EducationInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports